import { GatsbyBrowser } from 'gatsby';
import { getCookie } from '@lucid/utils';

const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] = () => {
  const { href, search, pathname } = window.location;
  if (window.ga) {
    const initialLandingPage = getCookie('initialLandingPage') || undefined;
    const ltAnonymousId = getCookie('lt-anonymous-id') || undefined;

    window.ga('set', 'location', href);
    window.ga('set', 'page', `${pathname}${search}`);
    window.ga('set', 'dimension1', search || 'undefined');
    window.ga('set', 'dimension2', initialLandingPage || 'undefined');
    window.ga('set', 'dimension3', ltAnonymousId || 'undefined');
  }

  if (window.dataLayer) {
    window.dataLayer.push({ originalLocation: href });
  }

  if (search.includes('showEditLink=1')) {
    window.localStorage.setItem('showEditLink', '1');
  }
};

const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
  if (location?.hash) {
    const element = document?.querySelector(`${location.hash}`) as HTMLElement;
    const item = element?.offsetTop;

    // Scroll to the the height minus the height of the navbar
    if (item) {
      window.scrollTo({
        top: item - 70,
        behavior: 'smooth',
      });
    }
  }
};

export { onInitialClientRender, onRouteUpdate };
